import axios from "../config"

class AppointService{
    axios;
    constructor(){
        this.axios = axios;
    }
    getAppointment(fromDate,toDate,status,doctorId) {
      let url = `apppointments`
      return axios.get(url,{params:{
        fromDate,toDate,status,doctorId
      }}).then(request => request.data);
    }
    getAppointmentByRecordId(recordId,patientId,doctorId) {
      let url = `apppointments/record`
      return axios.get(url,{params:{
        recordId,patientId,doctorId
      }}).then(request => request.data);
    }
    addAppointment(apppointments) {
      let url = `/apppointments`;
      return this.axios.post(url, apppointments).then(request => request.data);
    }
    updateAppointment(apppointments) {
      let url = `/apppointments/${apppointments.appointmentId}`;
      return this.axios.put(url, apppointments).then(request => request.data);
    }
    deleteAppointment(apppointments) {
      let url = `/apppointments/${apppointments.appointmentId}`;
      return this.axios.delete(url).then(request => request.data);
    }
    getAppointmentCurrentDate() {
      let url = `apppointments/currentdate`
      return axios.get(url).then(request => request.data);
    }
    getAppointCount(fromDate,toDate) {
      let url = `apppointments/count`
      return axios.get(url,{params:{
        fromDate,toDate
      }}).then(request => request.data);
    }
}

const service = new AppointService();
export default service;